import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

//SIP-842: local bundle (no S3)
import './imf-cpl-parser-v3.js';

//SIP-842: hybrid embed; cleaned Strapi embed HTML rendered via dangerouslySetInnerHTML
const CPL_EMBED_HTML = `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Manrope:wght@500;600;700;800&amp;display=swap"><style>
    .imf-cpl-embed,
    .imf-cpl-embed * {
      white-space: normal !important;
    }
    .imf-cpl-embed [hidden] {
      display: none !important;
    }
    .imf-cpl-embed {
      display: block;
      box-sizing: border-box;
      --bg-top: #f7fbff;
      --bg-bottom: #edf2f8;
      --surface: #ffffff;
      --surface-strong: #e8f0fb;
      --border: #cdd7e3;
      --text: #132338;
      --muted: #4d627a;
      --accent: #00539f;
      --accent-strong: #003f79;
      --ok: #0f6d41;
      --ok-bg: #e5f5ec;
      --fail: #b3261e;
      --fail-bg: #fdecea;
      --warn: #8a5a00;
      --warn-bg: #fff4d9;
      --radius-lg: 20px;
      --radius-md: 14px;
      --radius-sm: 10px;
      --shadow-lg: 0 24px 54px rgba(18, 52, 94, 0.1);
      --shadow-sm: 0 10px 24px rgba(18, 52, 94, 0.08);
      --font-ui: "Manrope", "Avenir Next", "Segoe UI", sans-serif;
    }
    .imf-cpl-embed,
    .imf-cpl-embed * {
      box-sizing: border-box;
    }
    .imf-cpl-embed {
      font-family: var(--font-ui);
      color: var(--text);
      background: radial-gradient(circle at 8% -12%, rgba(0, 83, 159, 0.2), transparent 32%), radial-gradient(circle at 92% 4%, rgba(14, 103, 191, 0.14), transparent 28%), linear-gradient(180deg, var(--bg-top) 0%, var(--bg-bottom) 100%);
      line-height: 1.5;
    }
    .imf-cpl-embed .page {
      width: min(1120px, calc(100% - 2rem));
      margin: 0 auto;
      padding: 2rem 0 1rem;
      display: grid;
      gap: 1.4rem;
    }
    .imf-cpl-embed .hero,
    .imf-cpl-embed .panel {
      background: color-mix(in oklab, var(--surface) 94%, #f9fcff);
      border: 1px solid rgba(0, 83, 159, 0.15);
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-lg);
    }
    .imf-cpl-embed .hero {
      padding: 2.1rem 2.2rem;
      position: relative;
      overflow: clip;
    }
    .imf-cpl-embed .hero::after {
      content: "";
      position: absolute;
      width: 200px;
      aspect-ratio: 1;
      border-radius: 999px;
      top: -60px;
      right: -45px;
      background: radial-gradient(circle at 45% 45%, rgba(0, 83, 159, 0.35), rgba(0, 83, 159, 0));
      pointer-events: none;
    }
    .imf-cpl-embed h1 {
      margin: 0;
      font-size: clamp(1.9rem, 3vw, 2.7rem);
      line-height: 1.05;
      letter-spacing: -0.02em;
      max-width: 22ch;
    }
    .imf-cpl-embed .hero p {
      margin: 0.9rem 0 0;
      color: var(--muted);
      max-width: 70ch;
      font-size: 1rem;
    }
    .imf-cpl-embed .hero code,
    .imf-cpl-embed footer code {
      background: var(--surface-strong);
      border: 1px solid rgba(0, 83, 159, 0.18);
      border-radius: 6px;
      padding: 0.05rem 0.4rem;
      font-size: 0.92em;
    }
    .imf-cpl-embed .panel {
      padding: 1.6rem;
      box-shadow: var(--shadow-sm);
    }
    .imf-cpl-embed .panel h2 {
      margin: 0;
      font-size: 1.2rem;
      letter-spacing: -0.02em;
    }
    .imf-cpl-embed .panel-sub {
      margin: 0.45rem 0 1.15rem;
      color: var(--muted);
      font-size: 0.95rem;
    }
    .imf-cpl-embed form {
      white-space: normal;
      margin: 0;
    }
    .imf-cpl-embed .drop-zone {
      display: block;
      border: 2px dashed rgba(0, 83, 159, 0.35);
      border-radius: var(--radius-md);
      background: var(--surface-strong);
      padding: 2.2rem 1.2rem;
      text-align: center;
      cursor: pointer;
      transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;
      outline: none;
    }
    .imf-cpl-embed .drop-zone:hover,
    .imf-cpl-embed .drop-zone:focus-visible,
    .imf-cpl-embed .drop-zone.dragging {
      border-color: var(--accent);
      background: #ddebfc;
    }
    .imf-cpl-embed .drop-zone.dragging {
      transform: scale(1.01);
    }
    .imf-cpl-embed .drop-zone input[type="file"] {
      display: none;
    }
    .imf-cpl-embed .drop-icon {
      color: var(--accent);
      margin-bottom: 0.5rem;
    }
    .imf-cpl-embed .drop-hint {
      margin: 0;
      color: var(--muted);
      font-size: 0.98rem;
    }
    .imf-cpl-embed .linkish {
      color: var(--accent-strong);
      font-weight: 800;
      text-decoration: underline;
      text-underline-offset: 0.2em;
    }
    .imf-cpl-embed .file-name {
      margin: 0.6rem 0 0;
      font-size: 0.88rem;
      font-weight: 700;
      color: var(--accent-strong);
      word-break: break-all;
    }
    .imf-cpl-embed .upload-actions {
      margin-top: 1.1rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.9rem;
    }
    .imf-cpl-embed main#imf-cpl-parser-widget button#submit-btn,
    .imf-cpl-embed #cpl-export-txt-btn {
      box-sizing: border-box !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      line-height: 1 !important;
      font-family: inherit !important;
      font-size: 0.95rem !important;
      font-weight: 800 !important;
      padding: 0.62rem 1.3rem !important;
      margin: 0 !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      white-space: nowrap !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      border: none !important;
      border-radius: var(--radius-sm) !important;
      background: var(--accent) !important;
      color: #fff !important;
      cursor: pointer !important;
      vertical-align: middle !important;
      transition: filter 0.15s ease, background-color 0.15s ease;
    }
    .imf-cpl-embed main#imf-cpl-parser-widget button#submit-btn:hover,
    .imf-cpl-embed #cpl-export-txt-btn:hover {
      filter: brightness(1.08);
      background: var(--accent) !important;
    }
    .imf-cpl-embed main#imf-cpl-parser-widget button#submit-btn:disabled,
    .imf-cpl-embed #cpl-export-txt-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    .imf-cpl-embed #validation {
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      background: #fafdff;
      padding: 1.1rem 1.2rem;
      font-size: 0.95rem;
    }
    .imf-cpl-embed .badge {
      display: inline-block;
      font-size: 0.72rem;
      font-weight: 800;
      letter-spacing: 0.06em;
      border-radius: 999px;
      padding: 0.16rem 0.62rem;
      white-space: nowrap;
    }
    .imf-cpl-embed .badge.ok {
      color: var(--ok);
      background: var(--ok-bg);
      border: 1px solid rgba(15, 109, 65, 0.3);
    }
    .imf-cpl-embed .badge.fail {
      color: var(--fail);
      background: var(--fail-bg);
      border: 1px solid rgba(179, 38, 30, 0.3);
    }
    .imf-cpl-embed .badge.warn {
      color: var(--warn);
      background: var(--warn-bg);
      border: 1px solid rgba(138, 90, 0, 0.3);
    }
    .imf-cpl-embed .badge.info {
      color: var(--muted);
      background: #eef2f7;
      border: 1px solid var(--border);
    }
    .imf-cpl-embed .muted {
      color: var(--muted);
      margin: 0;
      font-size: 0.875rem;
    }
    .imf-cpl-embed #validation p {
      margin: 0.4rem 0 0;
      color: var(--muted);
      font-size: 0.9rem;
    }
    .imf-cpl-embed ul.checks {
      margin: 0.5rem 0 0 1.1rem;
      padding: 0;
    }
    .imf-cpl-embed ul.checks li {
      margin: 0.35rem 0;
      font-size: 0.9rem;
    }
    .imf-cpl-embed .fatal {
      color: var(--fail);
    }
    .imf-cpl-embed .warn {
      color: var(--warn);
    }
    .imf-cpl-embed .report-head {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 0.8rem;
      margin-bottom: 0.45rem;
    }
    .imf-cpl-embed .report-card {
      border: 1px solid var(--border);
      border-radius: var(--radius-md);
      background: #fafdff;
      overflow: hidden;
    }
    .imf-cpl-embed #report.panel {
      white-space: pre-wrap;
      font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
      font-size: 0.82rem;
      background: #fbfdff;
      border: none;
      border-radius: 0;
      padding: 0.85rem 1rem;
      margin: 0;
      min-height: 4rem;
      color: var(--text);
      box-shadow: none;
    }
    .imf-cpl-embed #report.placeholder {
      color: var(--muted);
    }
    .imf-cpl-embed .imf-cpl-boot {
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
      padding: 0;
      margin: 0;
    }
    .imf-cpl-embed footer {
      text-align: center;
      color: var(--muted);
      font-size: 0.82rem;
      padding-top: 0.5rem;
    }
    @media (max-width: 700px) {
      .imf-cpl-embed .hero,
      .imf-cpl-embed .panel {
        padding: 1.2rem;
      }
    }
    .imf-cpl-embed .badge {
      white-space: nowrap !important;
    }
    .imf-cpl-embed #report.panel {
      white-space: pre-wrap !important;
    }
  </style><main id="imf-cpl-parser-widget" class="page">
    <section class="hero" aria-labelledby="imf-title">
      <h1 id="imf-title">IMF CPL Parser</h1>
      <p>Upload an IMF Composition Playlist (<code>CompositionPlaylist</code>) and get a full analysis: versions, composition metadata, assets, track files, frame rate, screen aspect ratio, extension metadata and IMF spec checks.</p>
    </section>

    <section class="panel upload-panel" aria-labelledby="upload-title">
      <h2 id="upload-title">Step 1 — Choose a file</h2>
      <p class="panel-sub">Drop an IMF CPL XML anywhere in the box, or click to browse.</p>
      <form id="cpl-form" action="about:blank" onsubmit="return false;">
        <label id="drop-zone" class="drop-zone" for="cpl-file" role="button" tabindex="0"
          ondragenter="(function(el){el.classList.add('dragging');return false;})(this)"
          ondragleave="(function(el){el.classList.remove('dragging');return false;})(this)"
          ondragover="return false;"
          ondrop="(function(el,e){e.preventDefault();el.classList.remove('dragging');var f=e.dataTransfer&amp;&amp;e.dataTransfer.files;if(!f||!f.length)return false;var inp=document.getElementById('cpl-file');if(inp){try{inp.files=f;}catch(err){}}var fn=document.getElementById('file-name');if(fn){fn.hidden=false;fn.textContent=f[0].name;}var b=document.getElementById('submit-btn');if(b)b.disabled=false;return false;})(this,event)"
          onkeydown="(function(el,e){if(e.key==='Enter'||e.key===' '){e.preventDefault();var inp=document.getElementById('cpl-file');if(inp)inp.click();}})(this,event)">
          <input id="cpl-file" name="cpl" type="file" accept=".xml,text/xml,application/xml" required=""
            onchange="(function(i){var f=i.files&amp;&amp;i.files[0];var n=f?f.name:'';var fn=document.getElementById('file-name');if(fn){fn.hidden=!n;fn.textContent=n;}var b=document.getElementById('submit-btn');if(b)b.disabled=!f;})(this)">
          <div class="drop-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4"></path><path d="M7 9l5-5 5 5"></path><path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2"></path></svg></div>
          <p class="drop-hint">Drag &amp; drop your <strong>.xml</strong> here, or <span class="linkish">choose a file</span></p>
          <p id="file-name" class="file-name" hidden=""></p>
        </label>
        <div class="upload-actions">
          <button type="button" id="submit-btn" disabled onclick="(function(b){var fi=document.getElementById('cpl-file');var f=fi&amp;&amp;fi.files&amp;&amp;fi.files[0];if(!f)return;var vs=document.getElementById('validation-section');var rs=document.getElementById('report-section');if(vs)vs.hidden=false;if(rs)rs.hidden=false;})(this)">Analyze with validation</button>
        </div>
      </form>
    </section>

    <section class="panel" id="validation-section" aria-labelledby="validation-title" hidden="">
      <h2 id="validation-title">Step 2 — Validation</h2>
      <p class="panel-sub">Well-formedness and root element checks run when you submit a file.</p>
      <div id="validation" aria-live="polite">
        <span class="badge info">Not run</span>
        <p class="muted">Submit a file to see results.</p>
      </div>
    </section>

    <section class="panel report-panel" id="report-section" aria-labelledby="report-title" hidden="">
      <div class="report-head">
        <h2 id="report-title">Step 3 — Report</h2>
        <button type="button" id="cpl-export-txt-btn" onclick="(function(){var el=document.getElementById('report');if(!el||el.classList.contains('placeholder')){window.alert('Run a successful analysis first; nothing to export yet.');return;}var text=el.textContent||'';if(!text.trim()){window.alert('Report is empty.');return;}var blob=new Blob([text],{type:'text/plain;charset=utf-8'});var anchor=document.createElement('a');anchor.download='cpl-report.txt';var url='';var URLApi=window.URL||window.webkitURL;try{if(URLApi&amp;&amp;typeof URLApi.createObjectURL==='function'){url=URLApi.createObjectURL(blob);}}catch(e){}if(!url){url='data:text/plain;charset=utf-8,'+encodeURIComponent(text);}anchor.href=url;anchor.style.display='none';document.body.appendChild(anchor);anchor.click();document.body.removeChild(anchor);if(url.indexOf('blob:')===0&amp;&amp;URLApi&amp;&amp;typeof URLApi.revokeObjectURL==='function'){try{URLApi.revokeObjectURL(url);}catch(e2){}}})();">Download .txt report</button>
      </div>
      <p class="panel-sub">The full CPL summary appears here once validation succeeds.</p>
      <div class="report-card">
        <div id="report" class="panel placeholder" role="status">Report appears here when validation succeeds.</div>
      </div>
    </section>
  </main><footer></footer>`;

const CPLParser = () => {
  useEffect(() => {
    if (window.ImfCplParser && window.ImfCplParser.autoInitEmbeddedUi) {
      window.ImfCplParser.autoInitEmbeddedUi();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Disney Media Tech Specs | IMF CPL Parser</title>
      </Helmet>
      <div
        className='imf-cpl-embed'
        data-cpl-strapi='1'
        dangerouslySetInnerHTML={{ __html: CPL_EMBED_HTML }}
      />
    </>
  );
};

export default CPLParser;
